// Types
type Language = 'EN' | 'FR';

export type I18nResources = {
  [brand: string]: {
    [lang in Language]: {
      [key: string]: Record<string, string | Record<string, string>>;
    };
  };
};

const i18nCustomResources: I18nResources = {
  delcourtedition: {
    EN: {
      header: {
        'REWARDS': 'MY EXPERIENCES',
      },
      details: {
        "careAndRepair": "Care services",
        "lifebook": "My product lifebook",
        "composition": "Product details"
      },
      composition: {
        "materialSplit": "Materials"
      }
    },
    FR: {
      header: {
        'REWARDS': 'MES EXPÉRIENCES',
      },
    },
  },
  collectionparticuliere: {
    EN: {
      header: {
        'REWARDS': 'MY EXPERIENCES',
      },
    },
    FR: {
      header: {
        'REWARDS': 'MES EXPÉRIENCES',
      },
    },
  },
  andréeputman: {
    EN: {
      wallet: {
        "products_one": "{{count}} PIECE",
        "products_other": "{{count}} PIECES",
        "empty": "Your wallet is empty, start by adding a piece"
      },
      header: {
        "WALLET": "MY COLLECTION",
        "REWARDS": "MY PRIVILEGES",
        "SETTINGS": "MY PROFILE"
      },
      rewards: {
        "empty": "Come back later to enjoy some privileges!",
        "past_rewards": "PAST PRIVILEGES",
      },
      details: {
        "project": "Discover the story behind your piece",
        "history": "Discover the story behind your piece",
        "history_subtitle": "Each step tells the story of a place, a moment in time, and a unique history.",
        "lifebook": "Piece lifebook",
        "offerOrSell": "Offer or sell my piece",
        "lostOrStolen": "Lost or stolen piece",
        "composition": "Piece composition",
        "offer": "Offer my piece",
        "sell": "Sell my piece",
        "productDescription": "Piece description",
        "productDetails": "Piece details",
        "productInformation": "Piece information"
      },
      gift: {
        "personalizeCertificate": "Personalize your certificate transfer by offering much more than just a piece !",
        "sharePhotos": "You can also share photos of your piece to share and extend its story ...",
        "modal": {
          "subtitle": "Your piece transfer has been successfully completed. You can send a personalized message to the receiver.",
          "message": "Hello firstname, I am very happy to offer you this piece from brandName. To be able to claim it, along with its digital ownership certificate, and to enjoy all the associated exclusive services, please visit",
        },
      },
      sell: {
        "modal": {
          "subtitle": "Your piece sale has been successfully processed. You can send a personalized message to the receiver.",
          "message": "Hello firstname, I am very happy to transfer this piece from brandName to you. To claim it, along with its digital ownership certificate, and to enjoy all the associated exclusive services, please visit"
        }
      },
      resale: {
        "subtitle": "Resell in one-click and securely your pieces on our second-hand plateform’s partners.",
        "modal": {
          "title": "Piece resold",
          "subtitle": "Your piece has been successfully transferred to our platform’s partners."
        }
      },
      care: {
        "subtitle": "Please select on below the service requested for your piece.",
      },
      lock: {
        "title": "Lost or stolen piece",
        "subtitle": "Please provide a detailed description of the reason for locking the piece.",
        "success": "Piece locked successfully",
        "failure": "Unable to lock the piece. Please try again.",
      },
      unlock: {
        "title": "Unlock my piece",
        "toast": {
          "unlocked": "Piece already unlocked",
          "notFound": "Piece not found"
        },
        "modal": {
          "title": "Piece unlocked",
          "subtitle": "The piece has been successfully unlocked and is now available."
        },
        "info_1": "To quickly identify your piece and",
        "method": "Which method would you like to use to unlock your piece?",
        "nfcInfo": "To scan via NFC, simply bring your phone close to the piece, the chip is located inside the care label.",
      },
      buttons: {
        "addProduct": "ADD A PIECE",
        "lock": "LOCK MY PIECE",
        "unlock": "UNLOCK MY PIECE",
      },
      partners: {
        "empty": "Sorry, no partner for this piece",
      },
      errors: {
        "8000": "Piece not found, please check the unique identifier.",
        "9000": "Piece not found in your wallet.",
        "10000": "Piece not found in your wallet.",
      },
    },
    FR: {
      wallet: {
        "products_one": "{{count}} PIÈCE",
        "products_other": "{{count}} PIÈCES",
        "empty": "Votre wallet est vide, commencez par ajouter une pièce"
      },
      header: {
        "WALLET": "MA COLLECTION",
        "REWARDS": "MES PRIVILÈGES",
        "SETTINGS": "MON PROFIL"
      },
      rewards: {
        "subtitle": "Tous les avantages et services exclusifs que vous avez débloqués en achetant des pièces éligibles.",
        "empty": "Revenez prochainement pour accéder à vos privilèges !",
        "past_rewards": "HISTORIQUE DE MES PRIVILÈGES",
      },
      details: {
        "lifebook": "Carnet de vie de la pièce",
        "offerOrSell": "Offrir ou vendre ma pièce",
        "lostOrStolen": "Pièce perdue ou volée",
        "composition": "Composition de la pièce",
        "project": "Découvrez l’histoire de votre pièce",
        "history": "Découvrez l’histoire de votre pièce",
        "history_subtitle": "Chaque étape raconte un lieu, une époque et une histoire unique.",
        "offer": "Offrir ma pièce",
        "sell": "Vendre ma pièce",
        "productDescription": "Description de la pièce",
        "productDetails": "Détails de la pièce",
        "productInformation": "Informations de la pièce"
      },
      gift: {
        "personalizeCertificate": "Personnalisez le transfert de votre certificat en offrant bien plus qu'une simple pièce !",
        "sharePhotos": "Vous pouvez également partager des photos de votre pièce pour partager et étendre son histoire ...",
        "modal": {
          "subtitle": "Votre pièce a été transferée avec succès. Vous pouvez envoyer un message personnalisé au destinataire.",
          "message": "Bonjour firstname, je suis très heureux de vous offrir cette pièce de brandName. Pour pouvoir le deverrouiller, ainsi que son certificat de propriété numérique, et profiter de tous les services exclusifs associés, veuillez visiter",
        }
      },
      sell: {
        "modal": {
          "subtitle": "La vente de votre pièce a été traitée avec succès. Vous pouvez envoyer un message personnalisé au destinataire.",
          "message": "Bonjour firstname, je suis très heureux de vous transférer cette pièce de brandName. Pour pouvoir le revendiquer, ainsi que son certificat de propriété numérique, et profiter de tous les services exclusifs associés, veuillez visiter"
        }
      },
      resale: {
        "subtitle": "Revendez en un clic et en toute sécurité vos pièces sur les partenaires de notre plateforme d'occasion.",
        "modal": {
          "title": "Pièce revendue",
          "subtitle": "Votre pièce a été transférée avec succès aux partenaires de notre plateforme."
        }
      },
      care: {
        "subtitle": "Veuillez sélectionner ci-dessous le service demandé pour votre pièce.",
      },
      lock: {
        "title": "Pièce perdue ou volée",
        "subtitle": "Veuillez fournir une description détaillée de la raison du verrouillage de la pièce.",
        "success": "Pièce verrouillée avec succès",
        "failure": "Impossible de verrouiller la pièce. Veuillez réessayer.",
      },
      unlock: {
        "title": "Déverrouiller ma pièce",
        "toast": {
          "unlocked": "Pièce déjà déverrouillée",
          "notFound": "Pièce non trouvée"
        },
        "modal": {
          "title": "Pièce déverrouillée",
          "subtitle": "La pièce a été déverrouillée avec succès et est maintenant disponible."
        },
        "info_1": "Pour identifier rapidement votre pièce et",
        "method": "Quelle méthode souhaitez-vous utiliser pour débloquer votre pièce ?",
        "nfcInfo": "Pour scanner via NFC, il suffit d'approcher votre téléphone de la pièce, la puce se situe à l'intérieur de l'étiquette d'entretien.",
      },
      buttons: {
        "addProduct": "AJOUTER UNE PIÈCE",
        "lock": "VERROUILLER MA PIÈCE",
        "unlock": "DÉVERROUILLER MA PIÈCE",
      },
      partners: {
        "empty": "Désolé, aucun partenaire pour cette pièce",
      },
      errors: {
        "8000": "Pièce non trouvée, veuillez vérifier l'identifiant unique.",
        "9000": "Pièce non trouvée dans votre wallet.",
        "10000": "Pièce non trouvée dans votre wallet.",
      }
    }
  }
};

export default i18nCustomResources;